import {NgModule} from '@angular/core';
import {MatButtonModule} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";


import {NavbarVerticalStyle1Component} from './style-1.component';
import {TourModule} from '../../../../../../ajuda/tour/tour.module';
import {CdkNavigationComponent} from '@cdk/components/navigation/navigation.component';

@NgModule({
    imports: [
        MatButtonModule,
        MatIconModule,
        CdkNavigationComponent,
        TourModule,
        NavbarVerticalStyle1Component
    ],
    exports: [
        NavbarVerticalStyle1Component
    ]
})
export class NavbarVerticalStyle1Module {
}
